import React from 'react';

const LoadingComman = () => {
    return (
        <div className='absolute top-0 left-0 w-full h-screen flex items-center justify-center bg-white z-[999999]'>
            <div className='flex items-center justify-center'>
                <div className="inline-block relative w-20 h-20">
                    <div className="absolute top-8 w-3 h-3 rounded-full bg-blue-800 animate-pulse"></div>
                    <div className="absolute top-8 left-4 w-3 h-3 rounded-full bg-blue-800 animate-pulse" style={{ animationDelay: '0.1s' }}></div>
                    <div className="absolute top-8 left-8 w-3 h-3 rounded-full bg-blue-800 animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                    <div className="absolute top-8 left-12 w-3 h-3 rounded-full bg-blue-800 animate-pulse" style={{ animationDelay: '0.3s' }}></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingComman;